<template>
  <div class="cooperative-school">
    <el-form size="mini" :inline="true">
      <el-form-item label="下单日期">
        <el-date-picker v-model="ruleForm.buy_date" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']" placement="bottom-start"></el-date-picker>
      </el-form-item>

      <el-form-item label="订单类型">
        <el-select size="mini" v-model="ruleForm.buy_type" placeholder="请选择" style="width: 200px">
          <el-option label="全部" value=""></el-option>
          <el-option label="存储空间" value="1"></el-option>
          <el-option label="流量" value="2"></el-option>
          <el-option label="时长" value="3"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-button @click="search">查询</el-button>
      </el-form-item>

      <el-form-item>
        <el-button @click="CreateOrder" type="primary">新建订单</el-button>
      </el-form-item>
    </el-form>
    <div class="table-style">
      <el-table size="mini" :data="tableData" :header-cell-style="{ background: '#f5f7fa' }">
        <el-table-column width="50" align="center" label="序号">
          <template slot-scope="scope">
            <span>{{ scope.$index + 1 + 20 * (page_no - 1) }}</span>
          </template>
        </el-table-column>

        <el-table-column width="200" align="left" prop="schoolName" label="校区名称"></el-table-column>

        <el-table-column width="100" align="left" label="订单类型">
          <template slot-scope="scope">
            <span v-if="scope.row.buy_type == '1'">存储空间</span>
            <span v-else-if="scope.row.buy_type == '2'">流量</span>
            <span v-else-if="scope.row.buy_type == '3'">时长</span>
          </template>
        </el-table-column>

        <el-table-column width="100" align="left" label="购买数量">
          <template slot-scope="scope">
            <span v-if="scope.row.buy_type == '1' || scope.row.buy_type == '2'">
              <span v-if="scope.row.buy_num >= 1024 && scope.row.buy_num < 1048576">
                {{ parseFloat(scope.row.buy_num / 1024).toFixed(2) }}
                MB
              </span>
              <span v-else-if="scope.row.buy_num < 1024">{{ scope.row.buy_num }} KB
              </span>
              <span v-else>
                {{ parseFloat(scope.row.buy_num / 1024 / 1024).toFixed(2) }}
                GB
              </span>
            </span>

            <span v-else-if="scope.row.buy_type == '3'">{{ scope.row.buy_num }}天</span>
          </template>
        </el-table-column>

        <el-table-column width="100" align="left" prop="unit_price" label="购买单价(元)"></el-table-column>

        <el-table-column width="100" align="left" prop="total_amount" label="总金额(元)"></el-table-column>

        <el-table-column width="150" align="left" prop="pay_date" label="下单时间"></el-table-column>

        <el-table-column width="150" align="left" prop="remarks" label="备注"></el-table-column>

        <el-table-column width="200" align="left" prop="created_time" label="录入时间"></el-table-column>

        <el-table-column align="center" label="操作" width="100" fixed="right">
          <template slot-scope="scope">
            <i class="el-icon-delete" style="margin: 10px; cursor: pointer" @click="adminDeleteSchoolOrder(scope.row)"></i>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination-style">
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="page_no" :page-size="20" layout="total, prev, pager, next" :total="total"></el-pagination>
    </div>
    <el-dialog :title="schoolId ? '修改合作学校' : '新增合作学校'" :visible.sync="dialogVisible" width="60%">
      <el-form class="form-style" ref="form" :model="form" :rules="rules" label-width="100px" label-position="left" size="small">
        <el-form-item label="二级域名" required prop="domain">
          <el-input placeholder="请输入二级域名" v-model="form.domain" style="width: 400px">
          </el-input>
        </el-form-item>
        <el-form-item label="截止日期" required prop="off_time">
          <el-date-picker v-model="form.off_time" type="date" placeholder="请选择系统截止日期" value-format="yyyy-MM-dd" placement="bottom-start"></el-date-picker>
        </el-form-item>

        <el-form-item label="最大分校数" required prop="max_campus_num">
          <el-input-number v-model="form.max_campus_num" :precision="0"></el-input-number>
        </el-form-item>

        <el-form-item label="最大教师数" required prop="max_teacher_num">
          <el-input-number v-model="form.max_teacher_num" :precision="0"></el-input-number>
        </el-form-item>

        <el-form-item label="最大学生数" required prop="max_student_num">
          <el-input-number v-model="form.max_student_num" :precision="0"></el-input-number>
        </el-form-item>

        <el-form-item label="地区信息">
          <myDistrict :province.sync="form.province" :city.sync="form.city" :area.sync="form.area"></myDistrict>
        </el-form-item>

        <el-form-item label="客户标签">
          <el-select v-model="form.tagIds" multiple placeholder="请选择">
            <el-option v-for="item in schoolTagList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="备注">
          <el-input placeholder="请输入学校备注" v-model="form.remarks" style="width: 400px">
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="quitDialog">取 消</el-button>
        <el-button size="small" type="primary" @click="submit('form')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getEducationalInstitutionList,
  addEducationalInstitution,
  updateEducationalInstitution,
  getPrincipalUserList,
  adminGetSchoolTagList,
  adminGetSchoolOrderList,
  adminDeleteSchoolOrder,
} from '@/api/admin'

import myDistrict from '../../../../components/myDistrict/myDistrict.vue'

export default {
  name: 'look-order',
  data() {
    return {
      userList: [],
      dialogVisible: false,
      ruleForm: {
        buy_type: '',
        educational_institution_name: '',
        buy_date: [],
      },
      form: {
        educational_institution_name: '',
        domain: '',
        max_campus_num: 1,
        max_teacher_num: 1,
        max_student_num: 1,
        off_time: '',
        remarks: '',
        tagIds: [],
        province: '',
        city: '',
        area: '',
      },
      schoolId: '',
      schoolTagList: [], //标签页面
      tableData: [],
      total: 0,
      page_no: 1,
      rules: {
        educational_institution_name: [
          {
            required: true,
            message: '请输入学校名称',
            trigger: 'change',
          },
          {
            required: true,
            message: '请输入学校名称',
            trigger: 'blur',
          },
        ],
        domain: [
          {
            required: true,
            message: '请输入二级域名',
            trigger: 'change',
          },
          {
            required: true,
            message: '请输入二级域名',
            trigger: 'blur',
          },
        ],
        remarks: [
          {
            required: true,
            message: '请输入学校备注',
            trigger: 'change',
          },
          {
            required: true,
            message: '请输入学校备注',
            trigger: 'blur',
          },
        ],
        off_time: [
          { required: true, message: '请选择系统截止日期', trigger: 'change' },
          { required: true, message: '请选择系统截止日期', trigger: 'blur' },
        ],
      },
    }
  },

  components: { myDistrict },

  mounted() {
    this.adminGetSchoolOrderList()
  },
  methods: {
    //查询校区订单
    adminGetSchoolOrderList() {
      adminGetSchoolOrderList({
        schoolId: this.$route.query.id,
        buy_type: this.ruleForm.buy_type,
        start_date: this.ruleForm.buy_date[0],
        end_date: this.ruleForm.buy_date[1],
        page_no: this.page_no,
        page_size: this.page_size,
      }).then((res) => {
        console.log('校区订单')
        console.log(res)

        this.tableData = res.schoolOrderList
        this.total = res.total
      })
    },

    //查询校区标签
    adminGetSchoolTagList() {
      adminGetSchoolTagList().then((res) => {
        console.log('查询校区标签')
        console.log(res)
        this.schoolTagList = res.schoolTagList
      })
    },

    // 获取校长账号列表
    getPrincipalUserList() {
      getPrincipalUserList({
        page_size: 200,
      }).then((res) => {
        this.userList = res.principal_user_list
      })
    },
    quitDialog() {
      this.$refs['form'].resetFields()
      this.dialogVisible = false
    },
    search() {
      this.page_no = 1
      this.adminGetSchoolOrderList()
    },
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.schoolId) {
            updateEducationalInstitution({
              educational_institution_id: this.schoolId,
              educational_institution_name: this.form
                .educational_institution_name,
              domain: this.form.domain,
              max_campus_num: this.form.max_campus_num,
              max_teacher_num: this.form.max_teacher_num,
              max_student_num: this.form.max_student_num,
              off_time: this.form.off_time,
              remarks: this.form.remarks,
              tagIds: JSON.stringify(this.form.tagIds),
              province: this.form.province,
              city: this.form.city,
              area: this.form.area,
            }).then((res) => {
              console.log('修改学校信息')
              console.log(res)
              if (res.is_update) {
                this.$message.success('修改成功')
                this.quitDialog()
                this.getEducationalInstitutionList()
              }
            })
          } else {
            console.log('新建校区参数')
            console.log(this.form)
            addEducationalInstitution({
              educational_institution_name: this.form
                .educational_institution_name,
              domain: this.form.domain,
              max_campus_num: this.form.max_campus_num,
              max_teacher_num: this.form.max_teacher_num,
              max_student_num: this.form.max_student_num,
              off_time: this.form.off_time,
              remarks: this.form.remarks,
              tagIds: JSON.stringify(this.form.tagIds),
              province: this.form.province,
              city: this.form.city,
              area: this.form.area,
            }).then((res) => {
              console.log('新增合作校区')
              console.log(res)
              if (res.is_create) {
                this.$message.success('添加合作学校成功')
                this.quitDialog()
                this.getEducationalInstitutionList()
              }
            })
          }
        }
      })
    },
    // 获取合作学校列表
    getEducationalInstitutionList() {
      getEducationalInstitutionList({
        educational_institution_name: this.ruleForm
          .educational_institution_name,
        username: this.ruleForm.username,
        page_no: this.page_no,
      }).then((res) => {
        console.log('校区列表')
        console.log(res)
        this.tableData = res.educational_institution_list
        this.total = res.total
      })
    },

    GogoSchool(domain) {
      console.log('二级域名跳转')
      console.log(domain)
    },

    handleCurrentChange(val) {
      this.page_no = val
      this.adminGetSchoolOrderList()
    },

    //新建订单
    CreateOrder() {
      console.log('新建订单')
      // console.log(this.$route.query.id, 121541);

      // this.$router.push({ name: "create-order" });
      this.$router.push({
        name: 'create-order',
        query: {
          id: this.$route.query.id,
          name: this.$route.query.name,
        },
      })
    },

    //删除订单
    adminDeleteSchoolOrder(row) {
      console.log('删除校区订单')

      this.$confirm('确定要删除订单吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        adminDeleteSchoolOrder({
          schoolOrderId: row.id,
        }).then((res) => {
          console.log('删除校区订单返回')
          console.log(res)
          if (res.is_delete) {
            this.$message.success('删除成功')
            this.adminGetSchoolOrderList()
          }
        })
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.cooperative-school {
  padding: 20px;
  margin: 10px;
  background-color: #fff;
  border-radius: 5px;

  .form-style {
    margin-left: 15px;
  }

  .btn {
    margin-top: 15px;
  }
}
</style>
